import { render } from "./CollectionApeTraits.vue?vue&type=template&id=255e23de"
import script from "./CollectionApeTraits.vue?vue&type=script&lang=js"
export * from "./CollectionApeTraits.vue?vue&type=script&lang=js"

import "./CollectionApeTraits.vue?vue&type=style&index=0&id=255e23de&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__